module.exports = __webpack_public_path__ + "images/news-1.7ddc366.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/image/news-1.png
// module id = 646
// module chunks = 0